<template>
  <svg fill="none" height="100%" viewBox="0 0 512 512" xmlns="http://www.w3.org/2000/svg">
    <g>
      <path
        d="m353.138 220.207h-194.207c-4.682 0-9.173-1.86-12.484-5.171s-5.171-7.802-5.171-12.484v-61.793c0-63.2765 51.482-114.759 114.758-114.759 63.277 0 114.759 51.4825 114.759 114.759v61.793c0 4.682-1.86 9.173-5.171 12.484s-7.802 5.171-12.484 5.171zm-176.552-35.31h158.897v-44.138c0-43.8029-35.646-79.4487-79.449-79.4487-43.802 0-79.448 35.6458-79.448 79.4487z"
      />
      <path
        d="m406.103 485.034h-300.137c-29.2021 0-52.966-23.763-52.966-52.965v-194.207c0-29.202 23.7639-52.966 52.966-52.966h300.137c29.202 0 52.966 23.764 52.966 52.966v194.207c0 29.202-23.764 52.965-52.966 52.965zm-300.137-264.827c-4.683 0-9.1736 1.86-12.4846 5.171s-5.1711 7.802-5.1711 12.484v194.207c0 4.682 1.8601 9.173 5.1711 12.484s7.8016 5.171 12.4846 5.171h300.137c4.683 0 9.174-1.86 12.485-5.171s5.171-7.802 5.171-12.484v-194.207c0-4.682-1.86-9.173-5.171-12.484s-7.802-5.171-12.485-5.171z"
      />
    </g>
  </svg>
</template>
<script>
export default {
  name: "M4LockSvg"
};
</script>
